module.exports = new Promise((resolve, reject) => {
                            try {
                                let publicDomainOverride = window.localStorage.getItem('myHealthToolkitClientWebpackPublicDomainOverride');
                                let publicDomainComputed = window.location.hostname.startsWith('secure.') ? 'https://' + window.location.hostname.replace('secure.', '') : 'https://myhealthtoolkit.com';
                                const requestBasePath = (publicDomainOverride ?? publicDomainComputed) + '/secure-client/commercial-web-client-member-plan-comparison-tool/';
                                const script = document.createElement('script');
                                script.src = requestBasePath + 'remoteEntry.js';
                                script.onload = () => {
                                    resolve({
                                        get: (request) => window['module_federation_remote_commercial_web_client_member_plan_comparison_tool'].get(request),
                                        init: (arg) => {
                                            try {
                                                return window['module_federation_remote_commercial_web_client_member_plan_comparison_tool'].init(arg);
                                            } catch (error) {
                                                console.error('Remote container module_federation_remote_commercial_web_client_member_plan_comparison_tool already initialized', error);
                                            }
                                        }
                                    });
                                };
                                script.onerror = () => {
                                    reject();
                                }
                                document.head.appendChild(script);
                            } catch (error) {
                                reject();
                            }
                        });